import { render, staticRenderFns } from "./DescontoFormModal.vue?vue&type=template&id=aeb92b54&scoped=true"
import script from "./DescontoFormModal.vue?vue&type=script&lang=js"
export * from "./DescontoFormModal.vue?vue&type=script&lang=js"
import style0 from "./DescontoFormModal.vue?vue&type=style&index=0&id=aeb92b54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb92b54",
  null
  
)

export default component.exports